export default __webpack_public_path__ + "static/media/houseHero.e470373f.jpg";